import { createLazyComponent } from '@muse-web/router'

export const AsyncEmbedDialogContainer = createLazyComponent(
    () => import(/* webpackChunkName: 'dialog-embed' */ './EmbedDialogContainer'),
    'EmbedDialogContainer',
)
